import React, { useState } from 'react';
import './Applicationform.css';
import { FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Applicationform = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    collegeName: '',
    email: '',
    phoneNumber: '',
    role: '',
    resume: null,
    skills: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className='form'>

<div className="top-left-button-container">
      <Link to="/" className="top-left-button">
        <FaArrowLeft />
      </Link>
</div>
    <h2>Application Form</h2>
    <div className="form-container">
      <form onSubmit={handleSubmit} className="application-form">
        <div className="form-group">
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="collegeName">Reffered/Any other:</label>
          <input
            type="text"
            id="collegeName"
            name="collegeName"
            value={formData.collegeName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number:</label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="role">Role:</label>
          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
          >
            <option value="">--Select Role--</option>
            <option value="Flutter">Flutter</option>
            <option value="Python">Python</option>
            <option value="UIUX">UI/UX</option>
            <option value="Marketing">Marketing</option>
            <option value="WebDevelopment">Web Development</option>
            <option value="DevOps">DevOps</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="resume">Resume:</label>
          <input
            type="file"
            id="resume"
            name="resume"
            onChange={handleFileChange}
            required/>
        </div>
        <div className="form-group">
            <label htmlFor="batchStartDate">Batch Start Date:</label>
            <select
              id="batchStartDate"
              name="batchStartDate"
              value={formData.batchStartDate}
              onChange={handleChange}
              required
            >
              <option value="">--Select Batch Start Date--</option>
              <option value="2024-07-01">2024-07-01</option>
              <option value="2024-08-01">2024-08-01</option>
              <option value="2024-09-01">2024-09-01</option>
              <option value="2024-10-01">2024-10-01</option>
              <option value="2024-11-01">2024-11-01</option>
              <option value="2024-12-01">2024-12-01</option>
            </select>
          </div>
        <div className="form-group">
          <button type="submit">Submit</button>
        </div>
      </form>
      </div>
<div className='foo'>
<footer>
        <p>© 2018-2022 Motocross India Private Limited. All Rights Reserved.</p>
      </footer>
</div>
    </div>
  );
};
export default Applicationform;
